import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function DownloadDocxItem(props) {
    const { disabled, download, onDownload } = props;
    const handleDownload = () => {
        download();
        onDownload();
    };
    return (<Menu.Item disabled={disabled} onClick={handleDownload}>
      <Falcon icon="file-word"/>
      <Menu.ItemText primary={t({ message: 'Download DOCX', comment: 'Download DOCX label' })}/>
    </Menu.Item>);
}
